import type { PropType } from 'vue'
import type { SizeProps } from '#ui-composables/useSize'

const predefinedIconColors = [
  'eucalyptus',
  'mauve',
  'waterspout',
  'peach',
  'skyblue',
  'topaz',
  'icon-fill-eucalyptus',
  'icon-fill-mauve',
  'icon-fill-waterspout',
  'icon-fill-peach',
  'icon-fill-skyblue',
  'icon-fill-topaz',
] as const
export type IconColor = typeof predefinedIconColors[number]

type IconProps = {
  icon?: string
  color: IconColor
} & SizeProps

export const useIconProps = () => ({
  icon: String,
  color: {
    type: String as PropType<IconColor>,
    default: 'eucalyptus',
    validator: (value: IconColor) => predefinedIconColors.includes(value),
  },
  ...useSizeProps(),
})

export function useIcon() {
  function sizes(_props: IconProps) {
    return {
      small: {
        size: 36,
        iconSize: 20,
      },
      default: {
        size: 48,
        iconSize: 32,
      },
      large: {
        size: 64,
        iconSize: 40,
      },
    }[_props.size]
  }

  function getAvatarProps(_props: IconProps) {
    const size = sizes(_props).size

    return {
      color: _props.color.startsWith('icon-fill') ? _props.color : `icon-fill-${_props.color}`,
      size,
    }
  }

  function getIconProps(_props: IconProps) {
    const cleanIcon = (_props.icon || '').replace(/\b-?(bold|thin|fill|light)\b(?!-)/, '')
    const icon = `${cleanIcon}${cleanIcon.endsWith('-duotone') ? '' : '-duotone'}`
    const size = sizes(_props).iconSize

    return {
      icon,
      size,
    }
  }

  return {
    getAvatarProps,
    getIconProps,
  }
}
